const API_URL = process.env.REACT_APP_API_URL;


console.log('Environment:', process.env.NODE_ENV);
console.log('API URL:', process.env.REACT_APP_API_URL);
console.log(API_URL);

async function httpGetLatestDeadheads() {
  const response = await fetch(`${API_URL}/deadhead/latest`);
  const fetchedDeadheads = response.json();
  return await fetchedDeadheads;
}

async function httpGetDeadheadsBySearch(search) {
  try {
      const response = await fetch(`${API_URL}/deadhead/search`, {
        method: "post",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify(search),
      });

    const data = await response.json();  
    return data;
  } catch(err) {
    console.log("ERROR:", err);
    return {
      ok: false,
      error: err.message
    }
  }
}

async function httpAddDeadhead(deadhead) {

  try{

    return await fetch(`${API_URL}/deadhead/add`, {
      method: "post",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(deadhead),
    });

  } catch(err) {
    return {
      ok: false
    }
    
  }

}

async function httpModifyDeadhead(deadhead) {
  try {
    return await fetch(`${API_URL}/deadhead/modify`, {
      method: "put",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(deadhead),
    });
  } catch(err) {
    return {
      ok: false
    }
  }
}

async function httpDeleteDeadhead(id) {
    try {
    return await fetch(`${API_URL}/deadhead/delete/${id}`, {
      method: "delete",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(),
    });
  } catch(err) {
    return {
      ok: false
    }
  }
}

export {
    httpAddDeadhead,
    httpGetLatestDeadheads,
    httpModifyDeadhead,
    httpDeleteDeadhead,
    httpGetDeadheadsBySearch
};